module.exports = __webpack_public_path__ + "media/src/images/icons/blue_circle-4dfb641d869c35c54e4b94873e9599da.svg";